<template>
  <div>
    <SearchWithMultiSelectLegacy
      data-test-id="search"
      :hasError="hasMaxExclusionError"
      :label="label"
      :loadingOptions="loading"
      name="Users"
      :options="options"
      placeholderText=""
      :searchText="searchText"
      :totalOptions="options.length"
      :value="selectedUsers"
      @filter="handleFilter"
      @input="handleSelectionChange"
    >
      <template
        v-if="hasMaxExclusionError"
        v-slot:errorMessage
      >
        <div
          :class="$style.errorMessage"
          data-test-id="errorMessage"
        >
          <Icon
            :class="$style.errorIcon"
            icon="error"
          />
          {{ maxExclusionErrorMessage }}
        </div>
      </template>
    </SearchWithMultiSelectLegacy>
  </div>
</template>

<script>
import { Icon } from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import { notify } from 'client/util';
import { validate } from 'vee-validate3';
import Constants,
{
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import GroupsConstants from 'client/util/Constants/GroupsConstants';
import SearchWithMultiSelectLegacy from 'client/components/SearchWithMultiSelect/SearchWithMultiSelectLegacy.vue';

const mapUserToOption = ({ subtitle, title, value }) => ({ name: `${title} (${subtitle})`, value });

const systemUserCollection = StoreModuleMap[ItemTypeConsts.systemUser];
export default {
  name: 'SelectUserExemptionField',

  components: {
    Icon,
    SearchWithMultiSelectLegacy,
  },

  props: {
    disabled: Boolean,

    label: {
      type: String,
      default: 'Users',
    },

    value: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    maxExclusionErrorMessage: GroupsConstants.membershipSuggestions.maxExemptionsError,
    hasMaxExclusionError: false,
    loading: true,
    options: [],
    searchText: '',
    selectedUsers: [],
    users: [],
  }),

  async beforeMount() {
    await this.buildOptions();
    await this.updateValueNames();
  },

  methods: {
    ...mapActions(systemUserCollection, [
      'fetchUsersById',
      'listUsersForManager',
    ]),

    async buildOptions(searchTerm = '') {
      this.loading = true;

      try {
        const listOfUsers = await this.listUsersForManager({ searchTerm });
        this.options = listOfUsers.map(mapUserToOption);
      } catch {
        notify(Constants.error, 'There was a problem getting users list in exclusion field.');
        this.options = [];
      }

      this.loading = false;
    },

    /**
     * Handles changes to the search text
     */
    handleFilter(value) {
      this.searchText = value;
      this.buildOptions(this.searchText);
    },

    /**
     * Handles changes to selected values
     */
    async handleSelectionChange(value) {
      const result = await validate(value, 'maximumExemptions');
      const newValue = value.map(option => option.value);

      this.hasMaxExclusionError = !result.valid;
      // Go ahead and set selectedValues here so we don't have to lookup the name again
      this.selectedUsers = value;
      this.searchText = '';
      this.$emit('selectionChange', newValue);
      await this.buildOptions();
    },

    async updateValueNames() {
      const ids = this.value.map((x) => x.id);
      if (ids && ids.length) {
        const { results } = await this.fetchUsersById({ ids });

        const users = results.map((user) => ({
          title: `${user.lastname || 'Unknown'}, ${user.firstname || 'Unknown'}`,
          subtitle: user.email,
          value: user.id,
        }));

        this.selectedUsers = users.map(mapUserToOption);
      }
    },
  },
};
</script>
<style module>
label {
  text-transform: none !important;
}

.errorMessage {
  align-items: center;
  color: var(--jc-color-neutral-text-descriptive);
  display: flex;
  font-size: var(--jcBodySmall);
  line-height: 1.5;
  margin-top: var(--jc-spacer-x-small);
}

.errorIcon {
  color: var(--jc-color-error-base);
  margin-right: 5px;
}
</style>
